import type { EditorResource } from "@jurni/schemas";

/** Where Jurni Studio, the page editor, lives; the classic editor keeps `/editor/:id`. */
export const STUDIO_PATH = "/studio";

const segments = {
  funnel: "pages",
  "global-section": "global-sections",
  "buy-box": "buy-boxes",
} satisfies Record<EditorResource["kind"], string>;

const STUDIO_PAGE_PATH = new RegExp(
  `^${STUDIO_PATH}/${segments.funnel}/(\\d+)`,
);

export function editorHref(resource: EditorResource, query?: URLSearchParams) {
  const suffix = query?.toString();
  return `${STUDIO_PATH}/${segments[resource.kind]}/${resource.id}${suffix ? `?${suffix}` : ""}`;
}

export function editorSessionKey(resource: EditorResource) {
  return `${resource.kind}:${resource.id}`;
}

export function editorHomeHref() {
  return "/funnels";
}

export function buyBoxCreationHref() {
  return `${STUDIO_PATH}/${segments["buy-box"]}/create`;
}

export function isStudioPath(pathname: string) {
  return pathname === STUDIO_PATH || pathname.startsWith(`${STUDIO_PATH}/`);
}

/** The page a Studio URL edits, or null for any other URL. */
export function studioPageId(pathname: string) {
  const page = STUDIO_PAGE_PATH.exec(pathname);
  return page ? Number(page[1]) : null;
}
